'use client';
import LINK from '@/constants/LINK';
import { ITopBarItem } from '@/interfaces/homepage';
import { useReactQuerySession } from '@/hooks/reactQuerySession';
import CustomLink from '@/components/CustomLink';
import { QueryKeys } from '@/enums';

export const PreHeaderClientComponent = ({ topBarRightSideItem }: { topBarRightSideItem: ITopBarItem }) => {
  const authObject = useReactQuerySession({ queryConfig: { queryKey: [QueryKeys.layoutBoundarySession] } });
  const getRightSidePageUrl = (topBarRightSideItem: ITopBarItem): string => {
    let returnVal = '/';
    if (topBarRightSideItem?.PageUrl) {
      returnVal = topBarRightSideItem.PageUrl;
      if (topBarRightSideItem.PageUrl === LINK.SIGN_IN.url && authObject.isAuthenticated) {
        returnVal = LINK.SIGN_OUT.url;
      }
    }
    return returnVal;
  };
  return (
    <CustomLink prefetch={false} className="inline-flex items-center" href={getRightSidePageUrl(topBarRightSideItem)}>
      <span className="underline-custom [--underline-offset:3px]">
        {topBarRightSideItem.PageUrl === LINK.SIGN_IN.url ? (authObject.isAuthenticated ? 'Sign Out' : 'Sign In') : topBarRightSideItem.Name}{' '}
      </span>
    </CustomLink>
  );
};
